<template>
  <v-container class="twilio-whatsapp-shell textoPoppins pa-0" fluid @keydown.ctrl="abrirPegar">
    <v-card class="twilio-whatsapp-app elevation-6">
      <v-row class="ma-0 fill-height">
        <v-col cols="12" md="4" lg="4" class="pa-0 twilio-whatsapp-sidebar">
          <div class="wa-sidebar-header">
            <div class="d-flex align-center wa-header-actions">
              <v-avatar color="#00a884" size="42">
                <v-icon color="white">mdi-whatsapp</v-icon>
              </v-avatar>
              <div class="ml-3">
                <div class="wa-title">Twilio Agente</div>
                <div class="wa-subtitle" v-if="filtroVendedora">
                  {{ filtroVendedora.nombre }}<span v-if="tiempoCargaMs != null"> · {{ tiempoCargaMs }} ms</span>
                </div>
                <div class="wa-subtitle" v-else>
                  {{ filterChats.length }} conversaciones<span v-if="tiempoCargaMs != null"> · {{ tiempoCargaMs }} ms</span>
                </div>
              </div>
            </div>

            <div class="d-flex align-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small v-bind="attrs" v-on="on" @click="dialogSeguimiento.estatus = true">
                    <v-icon color="#54656f">mdi-information-outline</v-icon>
                  </v-btn>
                </template>
                <span>Información de seguimiento</span>
              </v-tooltip>

              <v-menu
                v-if="[334, 3015, 1, 568, 32, 718, 1183, 1258, 2155, 2268, 2269, 2342, 954, 2472, 1312, 2230, 2767, 2910].includes(getdatosUsuarioERPERP.iderp) || vendedorasTwilio.length"
                bottom
                offset-y
              >
                <template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                      <v-btn icon small v-bind="{ ...menuAttrs, ...tooltipAttrs }" v-on="{ ...menuOn, ...tooltipOn }">
                        <v-icon color="#54656f">mdi-account-switch-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Filtrar por vendedora</span>
                  </v-tooltip>
                </template>

                <v-list dense v-if="!vendedorasTwilio.length">
                  <v-list-item
                    v-for="(item, index) in vendedoras_plantel"
                    :key="index"
                    @click="filtroVendedora = item"
                  >
                    <v-list-item-icon class="mr-2">
                      <v-icon color="#00a884">mdi-account</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="text-caption">{{ item.nombre }}</v-list-item-title>
                  </v-list-item>
                </v-list>

                <v-list dense v-else>
                  <v-list-item
                    v-for="(item, index) in vendedorasTwilio"
                    :key="index"
                    @click="filtroVendedora = item"
                  >
                    <v-list-item-icon class="mr-2">
                      <v-icon color="#00a884">mdi-account</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="text-caption">{{ item.nombre }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <v-tooltip v-if="puedeExportarConversacionIA" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    :loading="exportandoUltimasConversaciones"
                    :disabled="exportandoUltimasConversaciones || !filterChats.length"
                    @click="descargarUltimas100Conversaciones"
                  >
                    <v-icon color="#54656f">mdi-download</v-icon>
                  </v-btn>
                </template>
                <span>Descargar últimas 100 conversaciones (JSON)</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small v-bind="attrs" v-on="on" @click="initialize(1)">
                    <v-icon color="#54656f">mdi-refresh</v-icon>
                  </v-btn>
                </template>
                <span>Actualizar chats</span>
              </v-tooltip>
            </div>
          </div>

          <div class="wa-search-panel">
            <v-text-field
              :readonly="filterChats ? false : true"
              v-model="buscarUsuario"
              hide-details
              dense
              solo
              flat
              clearable
              rounded
              :autofocus="buscarUsuarioActive"
              prepend-inner-icon="mdi-magnify"
              placeholder="Buscar o iniciar un chat"
              class="wa-search"
            ></v-text-field>

            <div class="wa-filter-row">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    small
                    class="wa-filter-btn"
                    :color="filtroControlIa ? 'teal' : 'white'"
                    v-bind="attrs"
                    v-on="on"
                    @click="filtroControlIa = true; filtroControlManual = false; filtroAtencion = false"
                  >
                    <v-icon :color="filtroControlIa ? 'white' : 'teal darken-2'">mdi-robot</v-icon>
                  </v-btn>
                </template>
                <span>Control IA (responde sola)</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    small
                    class="wa-filter-btn"
                    :color="filtroControlManual ? 'deep-orange' : 'white'"
                    v-bind="attrs"
                    v-on="on"
                    @click="filtroControlManual = true; filtroControlIa = false; filtroAtencion = false"
                  >
                    <v-icon :color="filtroControlManual ? 'white' : 'deep-orange darken-2'">mdi-account-tie</v-icon>
                  </v-btn>
                </template>
                <span>Control manual (humano tomó el chat)</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    small
                    class="wa-filter-btn"
                    :color="filtroAtencion ? 'red darken-2' : 'white'"
                    v-bind="attrs"
                    v-on="on"
                    @click="filtroAtencion = !filtroAtencion; if (filtroAtencion) { filtroControlIa = false; filtroControlManual = false }"
                  >
                    <v-icon :color="filtroAtencion ? 'white' : 'red darken-3'">mdi-alert-circle</v-icon>
                  </v-btn>
                </template>
                <span>ATENCIÓN — IA falló y está pausada (prioridad humana)</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    small
                    class="wa-filter-btn"
                    :color="filtroExamen ? 'red' : 'white'"
                    v-bind="attrs"
                    v-on="on"
                    @click="filtroExamen = !filtroExamen; if (filtroExamen) { filtroMetodosPago = false; filtroBeca = false }"
                  >
                    <v-icon :color="filtroExamen ? 'white' : 'red darken-2'">mdi-clipboard-text</v-icon>
                  </v-btn>
                </template>
                <span>Llegó a examen</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    small
                    class="wa-filter-btn"
                    :color="filtroBeca ? 'indigo' : 'white'"
                    v-bind="attrs"
                    v-on="on"
                    @click="filtroBeca = !filtroBeca; if (filtroBeca) { filtroExamen = false; filtroMetodosPago = false }"
                  >
                    <v-icon :color="filtroBeca ? 'white' : 'indigo darken-1'">mdi-school</v-icon>
                  </v-btn>
                </template>
                <span>Llegó a beca (beca explicada o más)</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    small
                    class="wa-filter-btn"
                    :color="filtroMetodosPago ? 'green' : 'white'"
                    v-bind="attrs"
                    v-on="on"
                    @click="filtroMetodosPago = !filtroMetodosPago; if (filtroMetodosPago) { filtroExamen = false; filtroBeca = false }"
                  >
                    <v-icon :color="filtroMetodosPago ? 'white' : 'green darken-2'">mdi-cash</v-icon>
                  </v-btn>
                </template>
                <span>Métodos de pago enviados</span>
              </v-tooltip>

              <v-btn fab small class="wa-filter-btn" :color="filtroMensajes ? 'red lighten-4' : 'white'" @click="filtroMensajes = true">
                <v-icon color="red">mdi-message-badge</v-icon>
              </v-btn>

              <v-btn
                rounded
                class="wa-filter-clear"
                @click="filtroMensajes = false, filtroControlIa = false, filtroControlManual = false, filtroAtencion = false, filtroExamen = false, filtroBeca = false, filtroMetodosPago = false, filtroVistos = false, etiqueta = null, filtroTiempo = null, filtroVendedora = null, filtroSinProspecto = null, filtroSinProspectoNoInteres = false, filtroIncompletos = null"
              >
                Todos!!
              </v-btn>

              <v-btn fab small class="wa-filter-btn" :color="filtroVistos ? 'grey darken-2' : 'white'" @click="filtroVistos = true">
                <v-icon :color="filtroVistos ? 'white' : 'grey darken-2'">mdi-message-bulleted-off</v-icon>
              </v-btn>

              <v-menu bottom offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn fab small color="white" class="wa-filter-btn" v-bind="attrs" v-on="on">
                    <v-icon :color="etiqueta ? etiqueta.color : 'grey darken-2'">mdi-checkbox-blank-circle</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item v-for="(item, index) in etiquetas" :key="index" @click="etiqueta = item">
                    <v-list-item-title class="text-caption">
                      <v-icon small :color="item.color">mdi-label</v-icon>
                      {{ item.text }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <v-menu bottom offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn fab small color="white" class="wa-filter-btn" v-bind="attrs" v-on="on">
                    <v-icon :color="filtroTiempo ? filtroTiempo.color : 'grey darken-2'">mdi-clock</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item v-for="(item, index) in tiempos" :key="index" @click="filtroTiempo = item">
                    <v-list-item-title class="text-caption">
                      <v-icon small :color="item.color">mdi-clock</v-icon>
                      {{ item.text }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <div v-if="accesosBoton" class="wa-select-tooltip">
                <v-select
                  class="wa-select wa-incompletos-select"
                  dense
                  hide-details
                  solo
                  flat
                  rounded
                  :items="opcionesIncompletos"
                  label="Incompletos"
                  v-model="filtroIncompletos"
                  item-value="value"
                  item-text="text"
                  clearable
                ></v-select>
              </div>
            </div>
          </div>

          <ListaContactos
            :filterChats="filterChats"
            :whatsapp-style="true"
            @verChat="verChat"
            :limite="limite"
            @cargar-mas="onCargarMasChats"
          />
        </v-col>

        <v-col cols="12" md="8" lg="8" class="pa-0 twilio-whatsapp-conversation">
          <div v-if="!chat" class="wa-empty-state">
            <v-icon size="96" color="#d1d7db">mdi-whatsapp</v-icon>
            <h2>WhatsApp CRM</h2>
            <p>Selecciona un chat para ver la conversación en tiempo real.</p>
          </div>

          <template v-else>
            <div class="wa-chat-header">
              <div class="d-flex align-center overflow-hidden">
                <v-avatar :color="!chat.nombre ? '#00a884' : '#dfe5e7'" size="44">
                  <v-icon color="white" v-if="!chat.nombre">mdi-account</v-icon>
                  <span v-else class="wa-avatar-text">{{ chat.nombre }}</span>
                </v-avatar>
                <div class="ml-3 overflow-hidden">
                  <div class="wa-chat-name">{{ chat.usuario }}</div>
                  <div class="wa-chat-meta" v-if="chat.folio">Folio {{ chat.folio }}</div>
                  <div class="wa-chat-timing" v-if="tiempoCargaChatMs != null">
                    twilio.chats.unico · {{ tiempoCargaChatMs }} ms
                  </div>
                </div>
                <v-chip
                  v-if="controlEstado"
                  x-small
                  label
                  class="ml-2 flex-shrink-0"
                  :color="chipControlColor"
                >
                  {{ chipControlTexto }}
                </v-chip>
              </div>

              <div class="wa-chat-actions">
                <v-btn
                  v-if="[1, 3, 568, 334, 3015, 2268, 2155, 2472, 1312,2230,954, 2767,2910].includes(getdatosUsuarioERPERP.iderp) && chat.folio"
                  small
                  rounded
                  depressed
                  color="#ffffff"
                  class="wa-action-btn"
                  @click="dialogReasignar.estatus = true"
                >
                  <v-icon small left>mdi-account-switch</v-icon>
                  Reasignar
                </v-btn>

                <v-btn
                  v-if="puedeLimpiarAgenteIa"
                  small
                  rounded
                  depressed
                  color="#ffffff"
                  class="wa-action-btn"
                  :loading="limpiandoAgente && modoLimpiarAgente === 'contexto'"
                  :disabled="limpiandoAgente"
                  title="Reinicia perfil VIA / contexto; conserva mensajes"
                  @click="abrirDialogReiniciarContexto"
                >
                  <v-icon small left>mdi-restore</v-icon>
                  Reiniciar CTX
                </v-btn>

                <v-btn
                  v-if="puedeLimpiarAgenteIa"
                  small
                  rounded
                  depressed
                  color="#ffebee"
                  class="wa-action-btn"
                  :loading="limpiandoAgente && modoLimpiarAgente === 'todo'"
                  :disabled="limpiandoAgente"
                  title="Borra mensajes de la línea y reinicia contexto"
                  @click="abrirDialogBorrarConversacion"
                >
                  <v-icon small left color="error">mdi-delete-outline</v-icon>
                  Borrar chat
                </v-btn>

                <v-btn
                  v-if="chat && chat.usuario"
                  small
                  rounded
                  depressed
                  color="#ffcdd2"
                  class="wa-action-btn"
                  :loading="bloqueandoNumero"
                  :disabled="bloqueandoNumero || limpiandoAgente"
                  title="Bloquear por spam: deja de guardar y procesar mensajes de este número"
                  @click="bloquearNumeroSpam"
                >
                  <v-icon small left color="error">mdi-block-helper</v-icon>
                  Bloquear spam
                </v-btn>

                <v-btn
                  v-if="[1, 3, 568, 334, 3015, 2268, 2155, 2472, 1312,2230,954, 2767,2910].includes(getdatosUsuarioERPERP.iderp) && !chat.folio"
                  small
                  rounded
                  depressed
                  color="#ffffff"
                  class="wa-action-btn"
                  @click="dialogAsignar.estatus = true"
                >
                  <v-icon small left>mdi-account-plus</v-icon>
                  Asignar
                </v-btn>

                <v-btn
                  v-if="puedeExportarConversacionIA"
                  icon
                  small
                  title="Ver / copiar JSON IA"
                  @click="abrirJsonConversacionIA('twilio-agente')"
                >
                  <v-icon color="#54656f">mdi-code-json</v-icon>
                </v-btn>

                <v-btn
                  v-if="puedeExportarConversacionIA"
                  icon
                  small
                  title="Descargar conversación"
                  @click="descargarConversacionIADirecto('twilio-agente')"
                >
                  <v-icon color="#54656f">mdi-download</v-icon>
                </v-btn>

                <v-menu top offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on" v-if="chat.idetiquetas != 6">
                      <v-icon color="#54656f">mdi-label-outline</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item v-for="(item, index) in etiquetas2" :key="index" @click="cambiarCategoria(item.idetiquetas)">
                      <v-list-item-title class="text-caption">
                        <v-icon small :color="item.color">mdi-label</v-icon>
                        {{ item.text }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-btn icon small @click="dialogComentariosAbiertoChat = true">
                  <v-icon color="#54656f">mdi-comment-plus-outline</v-icon>
                </v-btn>

                <v-btn icon small @click="dialogDescrip = true">
                  <v-icon color="#54656f">mdi-dots-vertical</v-icon>
                </v-btn>
              </div>
            </div>

            <section class="wa-chat-area">
              <v-container
                id="scroll-target"
                v-scroll:#scroll-target="onScroll"
                class="wa-messages-scroll overflow-y-auto elevation-0"
              >
                <MensajesWppTwilio
                  class="messages-chat elevation-0"
                  id="mensajesChat"
                  :whatsappStyle="true"
                  :mensajes="mensajes"
                  :alumno="alumno"
                  :wha="wha"
                  :chat="chat"
                  :verTodosLosMensajes="verTodosLosMensajes"
                  :asignacion="asignacion"
                  :numeroTwilio="numeroTwilio"
                  :url-media-prospecto="urlMediaAgente"
                  :url-media-asesor="urlMediaAgente"
                  @validayGuardaMensajes="validayGuardaMensajes"
                  :chats="getConversacionesAgente"
                  @verChat="verChat"
                  :composerDeshabilitadoPorControl="composerBloqueadoPorIa"
                  :mostrarAccionTomarControl="mostrarBotonTomarControl"
                  :cargandoAccionControl="accionControl"
                  @tomar-control="tomarControlConversacion"
                >
                  <template v-slot:antes-composer>
                    <div class="wa-draft-panel" :class="{ 'wa-draft-panel--min': panelIaMinimizado }">
                      <div class="wa-ia-bar px-2">
                        <span class="wa-ia-title">IA</span>
                        <span class="wa-ia-agent text-truncate" :title="etiquetaAgenteBarra">{{ etiquetaAgenteBarra }}</span>
                        <v-spacer />
                        <v-btn
                          x-small
                          color="indigo"
                          dark
                          class="mr-1"
                          :loading="generandoBorrador"
                          :disabled="iaBloqueadaPorHumano"
                          @click="generarBorradorIa"
                        >{{ panelIaMinimizado ? 'IA' : 'Responder' }}</v-btn>
                        <v-menu offset-y left :close-on-content-click="false">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon x-small v-bind="attrs" v-on="on" title="Ajustes IA">
                              <v-icon small>mdi-cog-outline</v-icon>
                            </v-btn>
                          </template>
                          <v-card min-width="280" class="pa-3">
                            <div class="text-caption font-weight-bold mb-2">Quién responde</div>
                            <v-select
                              v-model="marcaPrompt"
                              :items="marcasPrompt"
                              label="Marca"
                              dense
                              outlined
                              hide-details
                              class="mb-2"
                              menu-props="offset-y"
                            />
                            <v-select
                              v-model="idAgenteSeleccionado"
                              :items="agentesSelectItems"
                              label="Agente"
                              dense
                              outlined
                              hide-details
                              clearable
                              class="mb-2"
                              menu-props="offset-y"
                              @change="onCambioIdAgenteIa"
                            />
                            <v-select
                              v-if="versionesAgenteItems.length"
                              v-model="versionAgenteSeleccionada"
                              :items="versionesAgenteItems"
                              label="Versión"
                              dense
                              outlined
                              hide-details
                              clearable
                              class="mb-3"
                              menu-props="offset-y"
                              @change="onCambioVersionAgenteIa"
                            />
                            <v-alert
                              v-if="!idAgenteSeleccionado"
                              dense
                              text
                              type="warning"
                              class="mb-2"
                            >
                              <div class="text-caption">Sin agente. El hook usará Eduardo / versión publicada.</div>
                            </v-alert>
                            <v-divider class="mb-2" />
                            <v-btn
                              v-if="mostrarBotonTomarControl"
                              block
                              small
                              outlined
                              color="orange darken-2"
                              class="mb-1"
                              :loading="accionControl"
                              @click="tomarControlConversacion"
                            >Tomar control</v-btn>
                            <v-btn
                              v-if="mostrarBotonDevolverIa"
                              block
                              small
                              outlined
                              color="teal"
                              class="mb-1"
                              :loading="accionControl"
                              @click="devolverControlIa"
                            >Devolver a IA</v-btn>
                            <v-btn
                              block
                              small
                              text
                              :loading="cargandoContexto"
                              @click="cargarContextoIa(); tabIa = 0"
                            >Recargar contexto</v-btn>
                            <v-btn
                              block
                              small
                              text
                              :disabled="!jsonContextoIa"
                              @click="copiarContextoIaJson"
                            >Copiar JSON</v-btn>
                          </v-card>
                        </v-menu>
                        <v-btn
                          icon
                          x-small
                          :title="panelIaMinimizado ? 'Expandir' : 'Minimizar'"
                          @click="panelIaMinimizado = !panelIaMinimizado"
                        >
                          <v-icon small>{{ panelIaMinimizado ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                        </v-btn>
                      </div>

                      <template v-if="!panelIaMinimizado">
                        <v-tabs
                          v-model="tabIa"
                          dense
                          height="32"
                          background-color="transparent"
                          class="wa-ia-tabs px-1"
                        >
                          <v-tab class="text-caption">Ctx</v-tab>
                          <v-tab class="text-caption">Borrador</v-tab>
                        </v-tabs>
                        <v-tabs-items v-model="tabIa" class="wa-ia-tabs-items">
                          <v-tab-item>
                            <div v-if="contextoActivo" class="wa-contexto-box ma-1">
                              <div class="d-flex align-center mb-1">
                                <span class="text-caption grey--text text-truncate">
                                  {{ contextoActivo.marca && (contextoActivo.marca.marcaPrompt || contextoActivo.marca.label) }}
                                  · {{ contextoActivo.conversacion && contextoActivo.conversacion.mensajes_en_contexto }}/{{ contextoActivo.conversacion && contextoActivo.conversacion.total_mensajes }}
                                </span>
                                <v-spacer />
                                <v-btn x-small icon :disabled="!jsonContextoIa" @click="copiarContextoIaJson">
                                  <v-icon x-small>mdi-content-copy</v-icon>
                                </v-btn>
                              </div>
                              <pre class="wa-contexto-pre mb-0">{{ contextoIaResumen }}</pre>
                            </div>
                            <div v-else class="text-caption grey--text text-center pa-3">Contexto se carga al abrir el chat…</div>
                          </v-tab-item>
                          <v-tab-item>
                            <div v-if="borradorActivo" class="wa-draft-box ma-1">
                              <div class="wa-draft-text">{{ borradorActivo.borrador || borradorActivo.texto }}</div>
                              <div v-if="textoParaEnviarWhatsApp(borradorActivo)" class="mt-2">
                                <div class="wa-draft-wa">{{ textoParaEnviarWhatsApp(borradorActivo) }}</div>
                              </div>
                            </div>
                            <div v-else class="text-caption grey--text text-center pa-3">
                              La IA responde sola (webhook). Aquí ves el borrador en vivo.
                            </div>
                          </v-tab-item>
                        </v-tabs-items>
                      </template>
                    </div>
                  </template>
                </MensajesWppTwilio>
              </v-container>
            </section>
          </template>
        </v-col>
      </v-row>
    </v-card>

    <v-dialog v-model="dialogDescrip" max-width="500px" transition="dialog-transition">
      <v-card>
        <v-card-title primary-title>
          Etiquetas
        </v-card-title>
        <v-card-text class="black--text">
          <div v-for="(etiqueta, i) in etiquetas" :key="i">
            <v-icon :color="etiqueta.color">mdi-label</v-icon><b>{{ etiqueta.etiqueta }}</b>
            <br/>
            {{ etiqueta.detalles }}
            <br/>
            <br/>
            <v-divider></v-divider>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogComentariosAbiertoChat" max-width="600px" scrollable>
      <v-card v-if="chat && chat.idprospectos">
        <v-card-title class="headline">
          <v-icon small class="mr-2">mdi-chat-multiple</v-icon>
          Comentarios del Prospecto
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="min-height: 400px;">
          <ComentariosProspecto :idProspecto="chat.idprospectos" />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogComentariosAbiertoChat = false">
            <v-icon small class="mr-1">mdi-close</v-icon>
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ReasignarProspecto
      :dialogReasignar="dialogReasignar"
      v-if="dialogReasignar.estatus"
      :alumno="alumno"
      :wha="wha"
      :chat="chat"
    />

    <AsignarProspecto
      :escuela="1"
      :dialogAsignar="dialogAsignar"
      v-if="dialogAsignar.estatus"
      :alumno="alumno"
      :wha="wha"
      :chat="chat"
    />

    <InfoSeguimiento
      :dialogSeguimiento="dialogSeguimiento"
      v-if="dialogSeguimiento.estatus"
    />

    <DialogJsonConversacionIA
      v-if="puedeExportarConversacionIA"
      v-model="dialogJsonConversacionIA"
      :jsonStr="jsonConversacionIA"
      @copiar="copiarJsonConversacionIA"
      @descargar="descargarJsonConversacionIA"
    />

    <v-dialog v-model="dialogLimpiarAgente" max-width="420" persistent>
      <v-card>
        <v-card-title class="text-subtitle-1">
          {{ modoLimpiarAgente === 'todo' ? 'Borrar conversación' : 'Reiniciar contexto IA' }}
        </v-card-title>
        <v-card-text class="text-body-2">
          <template v-if="modoLimpiarAgente === 'todo'">
            Se borrarán <strong>todos los mensajes</strong> de este chat en la línea Agente
            y se reiniciará el contexto / perfil VIA (Eduardo + versión publicada).
            Esto no se puede deshacer.
          </template>
          <template v-else>
            Se reinicia el <strong>contexto y perfil VIA</strong> (borradores, control, datos).
            Los mensajes de WhatsApp <strong>se conservan</strong>.
          </template>
          <div v-if="chat" class="mt-3 grey--text text-caption">
            {{ chat.usuario }}
            <span v-if="chat.folio"> · Folio {{ chat.folio }}</span>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text :disabled="limpiandoAgente" @click="dialogLimpiarAgente = false">Cancelar</v-btn>
          <v-btn
            :color="modoLimpiarAgente === 'todo' ? 'error' : 'teal darken-1'"
            dark
            depressed
            :loading="limpiandoAgente"
            @click="confirmarLimpiarAgente"
          >
            {{ modoLimpiarAgente === 'todo' ? 'Borrar todo' : 'Reiniciar CTX' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Alerta v-if="respuestaAlerta" :parametros="parametros"/>
    <carga v-if="cargar"/>
  </v-container>
</template>

<script>
  import axios          from 'axios';
  import { mapGetters, mapActions } from 'vuex'
  import { io }         from "socket.io-client";

  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import MensajesWppTwilio     from '@/components/whatsapp/MensajesTwilioWpp.vue';
  import ListaContactos        from '@/components/whatsapp/ListaContactos.vue';
  import ReasignarProspecto    from '@/components/whatsapp/ReasignarProspecto.vue';
  import InfoSeguimiento       from '@/components/whatsapp/InfoSeguimiento.vue';
  import AsignarProspecto      from '@/components/whatsapp/AsignarProspecto.vue';
  import ComentariosProspecto  from '@/components/ComentariosProspecto.vue';
  import DialogJsonConversacionIA from '@/components/whatsapp/DialogJsonConversacionIA.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import mixinWhatsApp         from '@/mixins/mixinWhatsApp'
  import mixinEstatusWha       from '@/mixins/mixinEstatusWha'
  import mixinExamenTwilioAbrir from '@/mixins/mixinExamenTwilioAbrir'
  import mixinTwilioChatTiming from '@/mixins/mixinTwilioChatTiming'
  import mixinExportarConversacionTwilioIA from '@/mixins/mixinExportarConversacionTwilioIA'
  import mixinVendedorIaPanel from '@/mixins/mixinVendedorIaPanel'
  import { chatCoincideBusquedaTwilio } from '@/utils/examenUbicacionNotify'
  import { esUsuarioTwilioAdmin } from '@/config/twilioUsuariosAdmin'

  const TWILIO_LINEAS_AGENTE = [
    'whatsapp:+5215534952943',
    'whatsapp:+5215540435043',
  ]

  /** Timestamp comparable (ISO o "YYYY-MM-DD HH:mm:ss"). Misma regla que Unificado. */
  function fechaUltimoMensajeMs (chat) {
    if (!chat) return 0
    const raw =
      chat.fecha_ultimo_mensaje ||
      chat.ultimmensaje ||
      chat.ultimomensaje ||
      chat.fecha_creacion ||
      chat._bumpAt ||
      ''
    if (!raw) return 0
    if (typeof raw === 'number' && Number.isFinite(raw)) return raw
    const s = String(raw).trim()
    const isoLike = s.includes('T') ? s : s.replace(' ', 'T')
    const t = Date.parse(isoLike)
    if (Number.isFinite(t)) return t
    const t2 = new Date(s).getTime()
    return Number.isFinite(t2) ? t2 : 0
  }

  /** Un solo formato visible/ordenable: YYYY-MM-DD HH:mm:ss (hora local). */
  function formatFechaLista (value) {
    if (value == null || value === '') return ''
    let d
    if (value instanceof Date) {
      d = value
    } else if (typeof value === 'number' && Number.isFinite(value)) {
      d = new Date(value)
    } else {
      const s = String(value).trim()
      const isoLike = s.includes('T') ? s : s.replace(' ', 'T')
      d = new Date(isoLike)
      if (!Number.isFinite(d.getTime())) d = new Date(s)
    }
    if (!Number.isFinite(d.getTime())) return String(value)
    const p = (n) => String(n).padStart(2, '0')
    return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`
  }

  function ahoraFechaLista () {
    return formatFechaLista(Date.now())
  }

  function normalizarFechaChat (chat) {
    if (!chat || typeof chat !== 'object') return chat
    const raw = chat.fecha_ultimo_mensaje || chat.ultimmensaje || chat.ultimomensaje || ''
    if (!raw) return chat
    const norm = formatFechaLista(raw)
    if (!norm || norm === chat.fecha_ultimo_mensaje) return chat
    return { ...chat, fecha_ultimo_mensaje: norm }
  }

  function ordenarChatsPorMasReciente (lista) {
    return (Array.isArray(lista) ? lista : []).slice().sort((a, b) => {
      const tb = fechaUltimoMensajeMs(b)
      const ta = fechaUltimoMensajeMs(a)
      if (tb !== ta) return tb - ta
      return (Number(b.sinleer) || 0) - (Number(a.sinleer) || 0)
    }).map(normalizarFechaChat)
  }

  function digitosTelefonoTwilio (value) {
    const d = String(value || '').replace(/\D/g, '')
    if (!d) return ''
    return d.length >= 10 ? d.slice(-10) : d
  }

  function mismoUsuarioTwilio (a, b) {
    const da = digitosTelefonoTwilio(a)
    const db = digitosTelefonoTwilio(b)
    if (da && db) return da === db
    return String(a || '').trim() === String(b || '').trim()
  }

  function esLineaTwilioAgente (twilio) {
    if (!twilio) return false
    const raw = String(twilio).trim()
    if (TWILIO_LINEAS_AGENTE.includes(raw)) return true
    return ['5534952943', '5540435043'].includes(digitosTelefonoTwilio(raw))
  }

  export default {
    name: 'TwilioAgente',

    components:{
      Alerta,
      carga,
      MensajesWppTwilio,
      ListaContactos,
      ReasignarProspecto,
      InfoSeguimiento,
      AsignarProspecto,
      ComentariosProspecto,
      DialogJsonConversacionIA,

    },

    mixins: [ validarErrores, mixinEstatusWha, mixinWhatsApp, mixinExamenTwilioAbrir, mixinTwilioChatTiming, mixinExportarConversacionTwilioIA, mixinVendedorIaPanel ],


    data: () => ({
      skipMixinWhatsAppInit: true,
      dialogDescrip: false,
      dialogComentariosAbiertoChat: false,
      buscarPregunta:'',
      buscarActive:false,

      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      cargar: false,

      usuarios:[],

      usuario: null,
      buscarUsuario:'',
      buscarUsuarioActive:true,
      alumno:null,
      url: 'https://escuelakpi.club/imagenes-whatsapp/',
      /** Base preferida: API local/staging que sí tiene los archivos del agente */
      urlMediaAgenteApi: '',

      notSeen:false,
      searchMensaje:'',
      mensajes:[],
      chat:null,

      wha: null,
      notResponse:false,

      verTodosLosMensajes: 0,
      message: '',

      parametrosAsignarVendedora:{
        estatus: false
      },
      asignacion: null,
      conversaciones:[],
      asignados:[],
      loader: true,

      sonido: null,

      numeroTwilio: "whatsapp:+5215534952943",

      offsetTop: 0,

      limite: 30,
      tiempoCargaMs: null,
      chatsApiPageSize: 100,
      cargarTodasConversaciones: true,
      chatsPagination: null,
      cargandoMasChats: false,

      filtroControlIa: false,
      filtroControlManual: false,
      filtroAtencion: false,
      filtroExamen: false,
      filtroBeca: false,
      filtroMetodosPago: false,
      filtroSinProspecto: false,
      filtroSinProspectoNoInteres:false,
      filtroMensajes:false,

      filtroVistos: false,
      filtroIncompletos: null,
      opcionesIncompletos: [
        { text: 'Incompletos con interés', value: 'con_interes' },
        { text: 'Incompletos sin interés', value: 'sin_interes' },
        { text: 'Sin incompletos', value: 'sin_incompletos' },
      ],
      etapa: 8,
      etiqueta: null,

      filtroTiempo: false,
      escuela: '1',
      filtroVendedora: null,
      vendedoras_plantel:[],

      dialogReasignar: {
        estatus: false
      },
      dialogSeguimiento:{
        estatus: false
      },

      dialogAsignar:{
        estatus: false
      },

      bloqueandoNumero: false,


    }),

    computed: {
      ...mapGetters('login',['getdatosUsuarioERPERP']),
      ...mapGetters('twilio',['getConversacionesM','getConversacionesC', 'getConversacionesG','getConversacionesAgente']),

      accesosBoton( ){

        return esUsuarioTwilioAdmin(this.getdatosUsuarioERPERP.iderp) || [568, 334, 1, 32, 1312, 2230, 954, 2767, 2910].includes(this.getdatosUsuarioERPERP.iderp)

      },

      /** Audios/imágenes/PDF: en pruebas el archivo vive en el API; en prod en el CDN. */
      urlMediaAgente() {
        const api = String((axios.defaults && axios.defaults.baseURL) || '').replace(/\/?$/, '/')
        const enPruebas = process.env.VUE_APP_ENV === 'staging'
          || (typeof window !== 'undefined' && /pruebas/i.test(window.location.hostname))
        if (enPruebas && api) return `${api}imageneswhatsapplocal/`
        return this.url || 'https://escuelakpi.club/imagenes-whatsapp/'
      },

      filterChats(){

        // Preferir el store; si aún no sincroniza, usar fallback local
        let chats = (this.getConversacionesAgente && this.getConversacionesAgente.length)
          ? this.getConversacionesAgente
          : (Array.isArray(this.conversaciones) ? this.conversaciones : [])

        if (this.buscarUsuario) {
          const q = String(this.buscarUsuario).trim()
          chats = chats.filter(el => chatCoincideBusquedaTwilio(el, q))
        }

        chats = ordenarChatsPorMasReciente(chats)

        // Filtro control: IA vs manual (via_conversaciones)
        if (this.filtroAtencion) {
          chats = chats.filter(el => this.chatRequiereAtencion(el))
        } else {
          if (this.filtroControlIa && !this.filtroControlManual) {
            chats = chats.filter(el => !this.chatEnControlManual(el) && !this.chatRequiereAtencion(el))
          }
          if (this.filtroControlManual && !this.filtroControlIa) {
            chats = chats.filter(el => this.chatEnControlManual(el) && !this.chatRequiereAtencion(el))
          }
        }

        if (this.filtroExamen) {
          chats = chats.filter(el => !!el.llego_examen)
        }
        if (this.filtroBeca) {
          chats = chats.filter(el => !!el.llego_beca)
        }
        if (this.filtroMetodosPago) {
          chats = chats.filter(el => !!el.metodos_pago_enviados)
        }

        if( this.filtroMensajes ){
          chats = chats.filter( el => el.totalMensajes >= 4 )
        }

        if( this.etapa && this.etapa != 8 ){

          chats = chats.filter( el => el.idetapa == this.etapa )

        }

        if( this.filtroVistos ){

          chats = chats.filter( el => el.mio == 0 )

        }

        if( this.etiqueta ){

          chats = chats.filter( el => el.idetiquetas == this.etiqueta.idetiquetas )

        }

        if( this.filtroIncompletos ){
          if( this.filtroIncompletos == 'con_interes' ){
            chats = chats.filter(el => !el.folio && el.totalMensajes >= 2)
          } else if( this.filtroIncompletos == 'sin_interes' ){
            chats = chats.filter(el => !el.folio && el.totalMensajes  < 2)
          } else if( this.filtroIncompletos == 'sin_incompletos' ){
            chats = chats.filter(el => el.folio )
          }
        }

        if( this.filtroTiempo ){

          if( this.filtroTiempo.idtiempos == 1 ){
            chats = chats.filter( el => el.tiemporestante > 2 )
          }else if( this.filtroTiempo.idtiempos == 2 ){
            chats = chats.filter( el => el.tiemporestante > 0 && el.tiemporestante <= 2 )
          }else if( this.filtroTiempo.idtiempos == 3 ){
            chats = chats.filter( el => el.tiemporestante <= 0 )
          }


        }
        return chats
      },

      filterFiltro( ){

        let filtro = [
          { id: 2, text: `Nuevo (${this.getConversacionesAgente.filter( el => el.idetapa == 2).length})` },
          { id: 1, text: `Atrasado (${this.getConversacionesAgente.filter( el => el.idetapa == 1).length})` },
          { id: 4, text: `Con Info (${this.getConversacionesAgente.filter( el => el.idetapa == 4).length})` },
          { id: 5, text: `Sin info (${this.getConversacionesAgente.filter( el => el.idetapa == 5).length})` },
          { id: 7, text: `2da Contacto (${this.getConversacionesAgente.filter( el => el.idetapa == 7).length})` },
          { id: 8, text: `Todos (${this.getConversacionesAgente.length})` },
        ]

        return filtro
      },

      filterVendedoras( ){
        return this.vendedoras.filter( el => el.escuela == this.escuela )
      },


      tamanioPantalla () {
        return this.$vuetify.breakpoint.height -280
      },

    },

    watch:{
      filtroVendedora( value ){

        this.initialize( )

      },

      getConversacionesAgente () {
        this.$nextTick(() => this.tryAbrirChatExamenPendiente())
      },
    },

    async created (){
      await this.getVendedoras();
      this.crearTemplateSonido( )
      this.getTwilioTmp()
      this.initialize( 1 )
      this.syncPendingExamenDesdeRuta()
      this.cargarListaAgentesIa()
    },

    methods: {
      examenListasChats () {
        return [this.getConversacionesAgente, this.conversaciones]
      },

      examenRecargarChats () {
        return this.initialize(1)
      },

      getTwilioTmp(){
        let twilioTmp = sessionStorage.getItem('twilioTmp');
        if (twilioTmp) {
          this.buscarUsuario = twilioTmp;
          sessionStorage.removeItem('twilioTmp');
        }
      },
      formatearNombre(nombreCompleto) {
        if (!nombreCompleto || typeof nombreCompleto !== 'string') {
          return '';
        }

        return nombreCompleto
          .trim()                          // quita espacios sobrantes al inicio y final
          .toLowerCase()                   // todo a minúsculas primero
          .split(/\s+/)                    // divide por uno o más espacios
          .map(palabra =>
            palabra.charAt(0).toUpperCase() + palabra.slice(1)
          )
          .join(' ');
      },

      onScroll (e) {
        this.offsetTop = e.target.scrollTop
      },

      ...mapActions('twilio', ['guardarConversaciones', 'guardarConversacionesM', 'guardarConversacionesG', 'guardarConversacionesC', 'guardarConversacionesAgente'] ),

      /**
       * Misma regla que Unificado: el chat del último mensaje sube al tope
       * (entrante o saliente), sin loader ni refetch.
       */
      aplicarPreviewChatEnLista (usuario, patch) {
        if (!usuario || !patch) return
        const patchNorm = { ...patch }
        if (patchNorm.fecha_ultimo_mensaje) {
          patchNorm.fecha_ultimo_mensaje = formatFechaLista(patchNorm.fecha_ultimo_mensaje)
        }
        const actualizar = (lista) => {
          if (!Array.isArray(lista)) return []
          return lista.map((c) => (mismoUsuarioTwilio(c.usuario, usuario) ? { ...c, ...patchNorm } : c))
        }
        const conversaciones = ordenarChatsPorMasReciente(
          actualizar(this.getConversacionesAgente || this.conversaciones)
        )
        this.conversaciones = conversaciones
        if (typeof this.guardarConversacionesAgente === 'function') {
          this.guardarConversacionesAgente(conversaciones)
        }
      },

      validayGuardaMensajes () {
        if (!this.chat || !this.chat.usuario) return
        const texto = (this.message || '').trim()
        this.aplicarPreviewChatEnLista(this.chat.usuario, {
          mensaje: texto || this.chat.mensaje,
          mio: 1,
          sinleer: 0,
          fecha_ultimo_mensaje: ahoraFechaLista(),
          _bumpAt: Date.now(),
        })
      },

      validarMensajeEntrante (body) {
        if (!body) return
        const usuario = body.usuario || body.from
        if (!usuario) return
        const twilioLinea = body.twilio || body.to || null
        const lista = this.getConversacionesAgente || this.conversaciones || []
        const enLista = Array.isArray(lista) && lista.some((c) => mismoUsuarioTwilio(c.usuario, usuario))
        if (!enLista && twilioLinea && !esLineaTwilioAgente(twilioLinea)) return

        const esChatActivo = !!(this.chat && mismoUsuarioTwilio(this.chat.usuario, usuario))
        if (esChatActivo && Array.isArray(this.mensajes)) {
          const sid = body.messageSid
          const ya = sid && this.mensajes.some((m) => m && m.messageSid === sid)
          if (!ya) this.mensajes.push(body)
        }

        this.aplicarPreviewChatEnLista(usuario, {
          mensaje: body.mensaje != null ? body.mensaje : '',
          mio: body.mio != null ? body.mio : 0,
          type: body.type != null ? body.type : 1,
          sinleer: esChatActivo ? 0 : 1,
          fecha_ultimo_mensaje: ahoraFechaLista(),
          _bumpAt: Date.now(),
        })
      },

      backgroundUpdateChat (payload) {
        if (!payload || typeof payload !== 'object') return
        const usuario = payload.usuario || payload.from
        if (!usuario) return

        const twilioLinea = payload.twilio || payload.to || null

        const miId = Number(
          this.getdatosUsuarioERPERP &&
            (this.getdatosUsuarioERPERP.iderp || this.getdatosUsuarioERPERP.id_usuario)
        )
        const asignado = payload.usuario_asignado != null
          ? Number(payload.usuario_asignado)
          : null

        if (
          !this.accesosBoton &&
          Number.isFinite(asignado) &&
          asignado > 0 &&
          Number.isFinite(miId) &&
          miId > 0 &&
          asignado !== miId
        ) {
          return
        }

        const esMio = Number(payload.mio) === 1
        const ahoraMs = Date.now()
        const ahora =
          payload.fecha_ultimo_mensaje &&
          fechaUltimoMensajeMs({ fecha_ultimo_mensaje: payload.fecha_ultimo_mensaje }) >= ahoraMs - 2000
            ? formatFechaLista(payload.fecha_ultimo_mensaje)
            : ahoraFechaLista()
        const messageSid = payload.messageSid || null

        let conversaciones = Array.isArray(this.getConversacionesAgente) && this.getConversacionesAgente.length
          ? [...this.getConversacionesAgente]
          : (Array.isArray(this.conversaciones) ? [...this.conversaciones] : [])

        const idx = conversaciones.findIndex((c) => c && mismoUsuarioTwilio(c.usuario, usuario))
        // Si el chat ya está en Agente, súbelo aunque el payload traiga otra forma del número.
        // Solo ignora líneas que no son Agente cuando el chat no existe en la lista.
        if (idx < 0 && twilioLinea && !esLineaTwilioAgente(twilioLinea)) return

        let item
        if (idx >= 0) {
          item = {
            ...conversaciones[idx],
            mensaje: payload.mensaje != null ? payload.mensaje : conversaciones[idx].mensaje,
            mio: esMio ? 1 : 0,
            fecha_ultimo_mensaje: ahora,
            _bumpAt: ahoraMs,
            ventanaCerrada: 0,
            tiemporestante: 24,
          }
          if (payload.folio) item.folio = payload.folio
          if (payload.idprospectos) item.idprospectos = payload.idprospectos
          if (payload.usuario_asignado != null) item.usuario_asignado = payload.usuario_asignado
          if (payload.nombre_completo) item.nombre_completo = payload.nombre_completo
          if (payload.ProfileName) item.ProfileName = payload.ProfileName
          if (payload.idetapa != null) item.idetapa = payload.idetapa
          conversaciones.splice(idx, 1)
        } else {
          item = {
            usuario,
            mensaje: payload.mensaje || '',
            mio: esMio ? 1 : 0,
            type: payload.type != null ? payload.type : 1,
            fecha_ultimo_mensaje: ahora,
            _bumpAt: ahoraMs,
            ventanaCerrada: 0,
            tiemporestante: 24,
            ProfileName: payload.ProfileName || null,
            nombre_completo: payload.nombre_completo || payload.ProfileName || null,
            folio: payload.folio || null,
            idprospectos: payload.idprospectos || null,
            usuario_asignado: payload.usuario_asignado || null,
            idetapa: payload.idetapa != null ? payload.idetapa : null,
            existe: true,
            sinleer: 0,
          }
        }

        const chatAbierto = !!(this.chat && mismoUsuarioTwilio(this.chat.usuario, usuario))
        if (!chatAbierto && !esMio) {
          item.sinleer = (Number(item.sinleer) || 0) + 1
        }
        if (chatAbierto) {
          item.sinleer = 0
        }

        conversaciones.unshift(item)
        conversaciones = ordenarChatsPorMasReciente(conversaciones)
        this.conversaciones = conversaciones
        if (typeof this.guardarConversacionesAgente === 'function') {
          this.guardarConversacionesAgente(conversaciones)
        }
        if (typeof this.setVendedorAsignado === 'function') {
          this.setVendedorAsignado()
        }

        if (chatAbierto && Array.isArray(this.mensajes)) {
          const ya = messageSid && this.mensajes.some((m) => m && m.messageSid === messageSid)
          if (!ya) {
            this.mensajes.push({
              ...payload,
              usuario,
              twilio: payload.twilio || payload.to || this.numeroTwilio,
              mensaje: payload.mensaje,
              mio: esMio ? 1 : 0,
              fecha_creacion: payload.fecha_creacion || ahora,
              messageSid,
            })
            this.$nextTick(() => {
              const el = document.getElementById('scroll-target')
              if (el) el.scrollTop = el.scrollHeight
            })
          }
          if (typeof this.onMensajeTwilioEnVivo === 'function') {
            this.onMensajeTwilioEnVivo(payload)
          }
        }
      },

      parseChatsApiResponse (data) {
        if (Array.isArray(data)) {
          return {
            chats: data,
            pagination: { hasMore: false, offset: 0, returned: data.length, limit: null },
          }
        }

        var chats = data && Array.isArray(data.chats) ? data.chats : []
        return {
          chats: chats,
          pagination: (data && data.pagination) || {
            hasMore: false,
            offset: 0,
            returned: chats.length,
            limit: null,
          },
        }
      },

      setVendedorAsignado () {
        if (!Array.isArray(this.conversaciones)) return

        const lista = this.vendedorasTwilio.length ? this.vendedorasTwilio : this.vendedoras_plantel
        if (lista && lista.length) {
          this.conversaciones.forEach(it => {
            const idUsuarioAsignado = Number(it.usuario_asignado)
            if (!idUsuarioAsignado) return
            const vendedor = lista.find(vp => Number(vp.iderp) === idUsuarioAsignado)
            if (vendedor) {
              it.vendedor = {
                ...vendedor,
                nombre: this.formatearNombre(vendedor.nombre),
              }
            }
          })
        }
      },

      async fetchChatsPage ({ offset = 0, escuela, numTwilio } = {}) {
        const numeroTwilio = this.numeroTwilio || numTwilio
        const payload = {
          twilio: numeroTwilio,
          idusuario: this.filtroVendedora ? this.filtroVendedora.iderp : this.getdatosUsuarioERPERP.iderp,
          escuela: escuela ? escuela : this.getEscuela,
          offset,
        }
        if (this.cargarTodasConversaciones) {
          payload.all = true
          payload.limit = 0
        } else {
          payload.limit = this.chatsApiPageSize
        }

        const t0 = offset === 0 ? performance.now() : null
        const response = await this.$http.post('twilio.chats', payload)
        if (t0 != null) {
          this.tiempoCargaMs = Math.round(performance.now() - t0)
        }
        const parsed = this.parseChatsApiResponse(response.data)
        const chats = parsed.chats.map(it => normalizarFechaChat({ ...it, sinleer: it.sinleer || 0 }))
        return { chats, pagination: parsed.pagination }
      },

      // Override del initialize del mixin: asegura sincronía local + store (patrón similar a Unificado)
      initialize ( escuela, numTwilio ) {
        this.cargar = true
        this.limite = 30
        this.tiempoCargaMs = null

        return this.fetchChatsPage({ offset: 0, escuela, numTwilio }).then(page => {
          this.conversaciones = ordenarChatsPorMasReciente(this.fusionarFechasLocales(page.chats))
          this.chatsPagination = page.pagination
          // Con all=true mostrar la lista completa (sin tope artificial de 30/100)
          if (this.cargarTodasConversaciones && page.chats && page.chats.length) {
            this.limite = page.chats.length
          }
          this.setVendedorAsignado()
          this.guardarConversacionesAgente(this.conversaciones)
          this.$nextTick(() => this.tryAbrirChatExamenPendiente())
        }).catch(error => {
          this.tiempoCargaMs = null
          const msg =
            (error && error.response && error.response.data && error.response.data.message)
              ? error.response.data.message
              : (error && error.message)
                ? error.message
                : 'Error al obtener chats'
          this.validarError(msg)
        }).finally(() => {
          this.cargar = false
        })
      },

      async onCargarMasChats ({ limiteVisible, total } = {}) {
        if (limiteVisible != null && total != null && limiteVisible < total) {
          this.limite = limiteVisible
          return
        }

        if (this.limite < this.filterChats.length) {
          this.limite += 50
          return
        }

        const pag = this.chatsPagination
        if (!pag || !pag.hasMore || this.cargandoMasChats) return

        this.cargandoMasChats = true
        try {
          const nextOffset = (pag.offset || 0) + (pag.returned || 0)
          const page = await this.fetchChatsPage({ offset: nextOffset })
          if (!page.chats.length) return

          this.conversaciones = this.conversaciones.concat(page.chats)
          this.chatsPagination = page.pagination
          this.setVendedorAsignado()
          this.guardarConversacionesAgente(this.conversaciones)
          this.limite += 50
        } catch (error) {
          console.error(error)
        } finally {
          this.cargandoMasChats = false
        }
      },

      getNombre( texto ){
        return texto.usuario
      },

      /** Últimas 100 por fecha de mensaje (respeta filtros activos de la lista). */
      descargarUltimas100Conversaciones () {
        const chats = ordenarChatsPorMasReciente(this.filterChats || [])

        return this.descargarUltimasConversacionesIA({
          origen: 'twilio-agente',
          limite: 100,
          chats,
          fetchMensajes: async (chat) => {
            const response = await this.$http.post('twilio.chats.unico', {
              twilio: this.numeroTwilio,
              usuario: chat.usuario,
            })
            return (response.data && response.data.conversacionCompleta) || []
          },
        })
      },

      async bloquearNumeroSpam () {
        if (!this.chat || !this.chat.usuario) {
          this.validarError('No hay chat seleccionado')
          return
        }
        const ok = window.confirm(
          `¿Bloquear ${this.chat.usuario} por spam?\n\nDejará de guardarse y procesarse cualquier mensaje de este número.`,
        )
        if (!ok) return

        this.bloqueandoNumero = true
        try {
          await this.$http.post('twilio.agente.bloquear', {
            usuario: this.chat.usuario,
            twilio: this.numeroTwilio,
            motivo: 'spam',
          })

          const usuarioBloqueado = this.chat.usuario
          let conversaciones = [...(this.getConversacionesAgente || this.conversaciones || [])]
          conversaciones = conversaciones.filter((c) => c.usuario !== usuarioBloqueado)
          this.conversaciones = conversaciones
          this.guardarConversacionesAgente(conversaciones)
          this.chat = null
          this.mensajes = []
          this.validarSuccess('Número bloqueado. Ya no se procesarán sus mensajes.')
        } catch (error) {
          const msg = (error && error.response && error.response.data && error.response.data.message)
            || (error && error.message)
            || 'No se pudo bloquear el número'
          this.validarError(msg)
        } finally {
          this.bloqueandoNumero = false
        }
      },

      chatEnControlManual(chat = {}) {
        if (!chat || typeof chat !== 'object') return false
        if (chat.humano_tomo_control === true || chat.humano_tomo_control === 1) return true
        if (String(chat.control_conversacion || '').toLowerCase() === 'humano') return true
        if (chat.ia_puede_responder === false || chat.ia_puede_responder === 0) return true
        return false
      },

      chatRequiereAtencion(chat = {}) {
        if (!chat || typeof chat !== 'object') return false
        if (chat.requiere_atencion === true || chat.requiere_atencion === 1) return true
        if (String(chat.etiqueta_atencion || '').toUpperCase() === 'ATENCION') return true
        if (/^atencion:/i.test(String(chat.motivo_pausa_ia || ''))) return true
        return false
      },

      ultimoMensajeDeConversacion (conversacion) {
        const lista = Array.isArray(conversacion) ? conversacion : []
        if (!lista.length) return null
        return lista.reduce((ultimo, actual) => {
          if (!ultimo) return actual
          return new Date(actual.fecha_creacion) > new Date(ultimo.fecha_creacion) ? actual : ultimo
        }, null)
      },

      /** Si el API trae fecha vieja (solo cliente), no bajar un chat recién bumpeado. */
      fusionarFechasLocales (chatsApi) {
        const prev = this.getConversacionesAgente || this.conversaciones || []
        const byUser = new Map()
        prev.forEach((c) => {
          const k = digitosTelefonoTwilio(c && c.usuario)
          if (k) byUser.set(k, c)
        })
        return (Array.isArray(chatsApi) ? chatsApi : []).map((chat) => {
          const local = byUser.get(digitosTelefonoTwilio(chat && chat.usuario))
          if (!local) return normalizarFechaChat(chat)
          const tApi = fechaUltimoMensajeMs(chat)
          const tLocal = fechaUltimoMensajeMs(local)
          if (tLocal <= tApi) return normalizarFechaChat(chat)
          return normalizarFechaChat({
            ...chat,
            fecha_ultimo_mensaje: local.fecha_ultimo_mensaje,
            _bumpAt: local._bumpAt || tLocal,
          })
        })
      },

      verChat( chat ){

        // Construimos el chat
        const payload = {
          twilio      : this.numeroTwilio,
          usuario     : chat.usuario,
        }

        // Vaciamos los mensajes
        this.cargar   = true
        this.mensajes = []

        const t0Chat = this.iniciarTiempoCargaChat()
        // Hacemos la petición de los mensajes
        return this.$http.post('twilio.chats.unico', payload ).then(response=>{
          this.finalizarTiempoCargaChat(t0Chat)

          // Guardamos los mensajes
          this.mensajes   = response.data.conversacionCompleta
          let bloqueo     = response.data.bloqueo

          const ultimoMensaje = this.ultimoMensajeDeConversacion(response.data.conversacionCompleta)
          const fechaServer = ultimoMensaje && ultimoMensaje.fecha_creacion
            ? ultimoMensaje.fecha_creacion
            : null
          const tServer = fechaServer ? fechaUltimoMensajeMs({ fecha_ultimo_mensaje: fechaServer }) : 0

          let conversaciones = [...(this.getConversacionesAgente || this.conversaciones || [])]

          for (const i in conversaciones) {
            if (!mismoUsuarioTwilio(conversaciones[i].usuario, chat.usuario)) continue
            const actual = conversaciones[i]
            const tLocal = fechaUltimoMensajeMs(actual)
            const usarServer = tServer >= tLocal
            conversaciones[i] = {
              ...actual,
              mensaje: ultimoMensaje && ultimoMensaje.mensaje != null ? ultimoMensaje.mensaje : actual.mensaje,
              mio: ultimoMensaje && ultimoMensaje.mio != null ? ultimoMensaje.mio : actual.mio,
              type: ultimoMensaje && ultimoMensaje.type != null ? ultimoMensaje.type : actual.type,
              fecha_ultimo_mensaje: formatFechaLista(usarServer ? fechaServer : actual.fecha_ultimo_mensaje),
              _bumpAt: Math.max(Number(actual._bumpAt) || 0, tServer, tLocal),
              sinleer: 0,
            }
          }

          conversaciones = ordenarChatsPorMasReciente(conversaciones)

          if( bloqueo ){
            chat.idetiquetas = 7
            chat.color = '#000000'
            chat.bloqueado = true
          }

          this.chat = chat
          this.conversaciones = conversaciones
          this.guardarConversacionesAgente( conversaciones )

          // Lo mandamos hasta abajo el scroll
          setTimeout(function(){
            document.getElementById('scroll-target').scrollTop = document.getElementById('scroll-target').scrollHeight
          },300)

          this.cargar   = false // termina el cargar
          this.alAbrirChatPanelIa()

        }).catch( error =>{
          this.limpiarTiempoCargaChat()
          const msg = (error && error.response && error.response.data && error.response.data.message)
            ? error.response.data.message
            : 'Error al abrir el chat'
          this.validarError(msg)
        }).finally( () => { this.cargar = false })
      },

      abrirPegar( event ){
        console.log( event )
      },

    },
  }
</script>

<style scoped lang="scss">
@import '@/assets/styles/twilio-whatsapp-layout.scss';

.wa-ia-bar {
  display: flex;
  align-items: center;
  min-height: 36px;
  gap: 4px;
}
.wa-ia-title {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: #3949ab;
}
.wa-ia-agent {
  font-size: 12px;
  max-width: 42%;
  color: #546e7a;
}
.wa-ia-tabs {
  border-top: 1px solid #eef1f4;
}
.wa-ia-tabs-items {
  max-height: min(28vh, 220px);
  overflow-y: auto;
}
.wa-draft-panel {
  border-top: 1px solid #dce1e4;
  background: #fafbfc;
  max-height: min(36vh, 280px);
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}
.wa-draft-panel--min {
  max-height: 40px;
}
.wa-draft-box {
  background: #fff8e1;
  border: 1px solid #ffe082;
  border-radius: 8px;
  padding: 10px 12px;
}
.wa-draft-text {
  white-space: pre-line;
  font-size: 13px;
  line-height: 1.4;
}
.wa-draft-wa {
  white-space: pre-line;
  font-size: 13px;
  line-height: 1.4;
  background: #e8f5e9;
  border-radius: 6px;
  padding: 8px 10px;
}
.wa-contexto-box {
  background: #f5f7fa;
  border: 1px solid #e0e4ea;
  border-radius: 8px;
  padding: 10px 12px;
}
.wa-contexto-pre {
  margin: 0;
  font-size: 11px;
  background: #fff;
  border-radius: 6px;
  padding: 8px;
  max-height: min(22vh, 160px);
  overflow: auto;
}
</style>
